// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3j7lm","footer":"ModalCreateQualiphyProcedure_footer__aYXeo","additionData":"ModalCreateQualiphyProcedure_additionData__2903u"};